<script lang="ts">
	import { formatAmountWithCurrency } from '@wiseed/wikit';
	import { t } from 'svelte-i18n';
	import type { BondsSimulator } from '@app/models/api/BondsSimulator';
	import type { TableProps } from '@wiseed/wikit';
	import { getMonthsBetween } from '@wiseed/wikit';
	import AppTable from '@app/components/AppTable.svelte';
	import {
		isObligationsTypeInteretsInFine,
		OperationsTypeInteretsEnum
	} from '@app/models/api/enums/ObligationsTypeInteretsEnum';

	export let infos: BondsSimulator;
	export let typeInteret: OperationsTypeInteretsEnum;

	let tableProps: TableProps;
	$: if (infos) {
		let dataTable;
		const length = infos.echeancier?.length;
		let letter = undefined;
		if (isObligationsTypeInteretsInFine(typeInteret)) {
			letter =
				typeInteret === OperationsTypeInteretsEnum.CAPITAL_IN_FINE_ET_INTERETS_TRIMESTRIELS
					? 'T'
					: typeInteret === OperationsTypeInteretsEnum.CAPITAL_IN_FINE_ET_INTERETS_MENSUELS
						? 'M'
						: typeInteret === OperationsTypeInteretsEnum.CAPITAL_IN_FINE_ET_INTERETS_SEMESTRIELS
							? 'S'
							: 'A';
		}
		dataTable = infos.echeancier.map((e, index) => {
			return {
				cells: [
					{
						classNames: 'whitespace-nowrap',
						data: {
							value:
								letter !== undefined
									? `${letter}${index + 1}`
									: `${index + 1} (${e.dureeEnMois} ${$t('date.months')})`
						}
					},
					{
						data: {
							value: formatAmountWithCurrency(e.capitalEnDebutDePeriode)
						}
					},
					{
						classNames: index === length - 1 ? 'text-primary font-bold' : 'text-primary',
						data: {
							value: formatAmountWithCurrency(e.capitalRembourseEnFinDePeriode)
						}
					},
					{
						classNames: 'text-primary',
						data: {
							value: formatAmountWithCurrency(e.interetsEnFinDePeriode)
						}
					},
					...(infos?.echeancier.some((e) => e.primeNonConversion > 0)
						? [
								{
									classNames: 'text-primary font-bold',
									data: {
										value: formatAmountWithCurrency(e.primeNonConversion)
									}
								}
							]
						: []),
					{
						classNames: 'text-primary font-bold',
						data: {
							value: formatAmountWithCurrency(e.totalRembourseEnFinDePeriode)
						}
					}
				]
			};
		});
		if (
			(typeInteret === OperationsTypeInteretsEnum.CAPITAL_IN_FINE_ET_INTERETS_MENSUELS ||
				typeInteret === OperationsTypeInteretsEnum.CAPITAL_IN_FINE_ET_INTERETS_TRIMESTRIELS) &&
			length > 5
		) {
			let separationLine = {
				cells: [
					{
						classNames: 'whitespace-nowrap',
						data: {
							value: '...'
						}
					},
					{
						data: {
							value: '...'
						}
					},
					{
						classNames: 'text-primary-light',
						data: {
							value: '...'
						}
					},
					{
						classNames: 'text-primary-light',
						data: {
							value: '...'
						}
					},
					{
						classNames: 'text-primary',
						data: {
							value: '...'
						}
					}
				]
			};
			dataTable = dataTable.slice(0, 3).concat(separationLine).concat(dataTable.slice(-2));
		}
		tableProps = {
			headers: {
				data: [
					{ label: $t('operation.simulator.timeline.period'), isMobile: true },
					{ label: $t('operation.simulator.timeline.capitalStart') },
					{ label: $t('operation.simulator.timeline.capitalEnd') },
					{ label: $t('operation.simulator.timeline.interestEnd') },
					...(infos?.echeancier.some((e) => e.primeNonConversion > 0)
						? [{ label: $t('operation.simulator.timeline.pnc') }]
						: []),
					{ label: $t('operation.simulator.timeline.total'), isMobile: true }
				]
			},
			data: [...dataTable],
			footer: [
				{
					classNames: ' font-bold',
					cells: [
						{
							data: {
								value: $t('operation.simulator.timeline.totalMonths', {
									values: {
										value: getMonthsBetween(
											infos.dateFinEmpruntOblig,
											infos.dateEmissionEmpruntOblig
										)
									}
								})
							}
						},
						{ data: { value: '' } },
						{ data: { value: '' } },
						{ data: { value: '' } },
						...(infos?.echeancier.some((e) => e.primeNonConversion > 0)
							? [
									{
										data: {
											value: formatAmountWithCurrency(
												infos.echeancier.reduce(
													(p, { primeNonConversion }) => p + primeNonConversion,
													0
												)
											)
										}
									}
								]
							: []),
						{
							data: {
								value: formatAmountWithCurrency(
									infos.echeancier.reduce(
										(p, { totalRembourseEnFinDePeriode }) => p + totalRembourseEnFinDePeriode,
										0
									)
								)
							}
						}
					]
				}
			]
		};
	}
</script>

<div class="px-3">
	<AppTable props={tableProps} />
</div>
